"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _comparisonActions = require("../../store/comparison/comparisonActions");
var _comparisonSelectors = require("../../store/comparison/comparisonSelectors");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useComparison = _interopRequireDefault(require("./useComparison"));
var _useComparisonSettings = _interopRequireDefault(require("./useComparisonSettings"));
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const handleMultipleValueSpecs = (product, specLabel) => {
  let uniqueSpecValues;
  const specValues = product.variants.map(variant => {
    var _variant$specLabel, _variant$specLabel2, _variant$specLabel3;
    return {
      value: (_variant$specLabel = variant[specLabel]) === null || _variant$specLabel === void 0 ? void 0 : _variant$specLabel.value[0].value,
      valueType: (_variant$specLabel2 = variant[specLabel]) === null || _variant$specLabel2 === void 0 ? void 0 : _variant$specLabel2.value[0].unitOfMeasure,
      valueText: (_variant$specLabel3 = variant[specLabel]) === null || _variant$specLabel3 === void 0 ? void 0 : _variant$specLabel3.valueText
    };
  });
  const isSameValueType = specValues.length > 1 && specValues.every(_ref => {
    let {
      valueType
    } = _ref;
    return valueType === specValues[0].valueType;
  });
  let specValueText;
  if (isSameValueType) {
    specValueText = getMultipleValuesWithSameUnit(specValues);
  } else {
    uniqueSpecValues = (0, _lodash.default)(specValues, obj => obj.valueText);
    const textValues = uniqueSpecValues.map(el => el.valueText);
    specValueText = `${uniqueSpecValues.length > 0 ? textValues.join('/') : '-'}`;
  }
  return specValueText;
};
const getMultipleValuesWithSameUnit = specValues => {
  let valuesText = '';
  specValues.forEach((variant, index) => {
    if (!valuesText.includes(variant.value) && valuesText.length !== 0) {
      valuesText += `/${variant.value}`;
    }
    if (valuesText.length === 0) {
      valuesText = `${variant.value}`;
    }
    if (index === specValues.length - 1) {
      valuesText += ` ${variant.valueType}`;
    }
  });
  return valuesText;
};
const useComparisonSpecs = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const characteristicGroups = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectProductCatalog).specGroups;
  const {
    products
  } = (0, _useComparison.default)();
  const specs = (0, _useAppSelector.useAppSelector)(_comparisonSelectors.selectComparisonSpecs);
  const {
    multipleValueCharacteristics
  } = (0, _useComparisonSettings.default)();
  (0, _react.useEffect)(() => {
    const productList = Object.values(products);
    const colorSpecs = {};
    productList.forEach(product => {
      if (!(product !== null && product !== void 0 && product.filterTree)) return;
      const colorValues = product.selectedVariant.characteristics.find(spec => spec.name === 'color').value.filter(color => {
        var _color$value;
        const rgx = /#\b[0-9A-Fa-f]{6}\b\s*\|\s*(.*)/;
        return rgx.test((_color$value = color.value) === null || _color$value === void 0 ? void 0 : _color$value.trim());
      }).map(value => {
        const [color, text] = value.value.split('|');
        return {
          colorValue: color,
          text: text
        };
      });
      colorSpecs[product.productId] = [...colorValues];
    });
    const colorGroup = {
      label: 'Colors',
      specs: [{
        label: 'color',
        values: colorSpecs
      }]
    };

    //grouped chars
    const specGroups = [];
    characteristicGroups === null || characteristicGroups === void 0 ? void 0 : characteristicGroups.forEach(group => {
      const specGroup = {
        label: group.name,
        specs: [...group.characteristics.map(spec => {
          return {
            label: spec.name,
            values: {}
          };
        })]
      };
      productList.forEach(product => {
        var _product$variants$, _product$variants$$gr;
        const samegroup = product === null || product === void 0 ? void 0 : (_product$variants$ = product.variants[0]) === null || _product$variants$ === void 0 ? void 0 : (_product$variants$$gr = _product$variants$.groupedCharacteristics) === null || _product$variants$$gr === void 0 ? void 0 : _product$variants$$gr.find(productGroup => {
          return productGroup.name === specGroup.label;
        });
        specGroup.specs.forEach(spec => {
          var _samegroup$specs;
          const productSpec = samegroup === null || samegroup === void 0 ? void 0 : (_samegroup$specs = samegroup.specs) === null || _samegroup$specs === void 0 ? void 0 : _samegroup$specs.find(productSpec => {
            return productSpec.name === spec.label;
          });
          let value;
          //This section handles values that differ between products and is currently empty (can be used in the future if needed)
          if (multipleValueCharacteristics !== null && multipleValueCharacteristics !== void 0 && multipleValueCharacteristics.includes(spec.label)) {
            const specValue = handleMultipleValueSpecs(product, spec.label);
            value = [{
              text: `${specValue}`,
              subText: spec.label
            }];
          } else {
            var _product$selectedVari;
            value = [{
              text: productSpec === null || productSpec === void 0 ? void 0 : productSpec.valueText,
              subText: spec.label,
              ...(spec.label === 'entertainment' && {
                duration: product === null || product === void 0 ? void 0 : (_product$selectedVari = product.selectedVariant) === null || _product$selectedVari === void 0 ? void 0 : _product$selectedVari.price.durationAmount
              })
            }];
          }
          spec.values[product.productId] = value;
        });
      });
      specGroups.push(specGroup);
    });
    dispatch((0, _comparisonActions.setComparisonSpecs)([colorGroup, ...specGroups]));
  }, [products]);
  return {
    specGroups: specs
  };
};
var _default = useComparisonSpecs;
exports.default = _default;